'use client'

import { FunctionComponent, ReactElement, useState, useEffect } from 'react'
import Icon from '../Icon/Icon'
import { Icons } from '../Icon/constants'
import { gtmPush, gtmCategory } from '../../utils/gtmHelpers'

type AccordionType = {
  items: {
    title: string | ReactElement
    content: ReactElement
  }[]
  defaultIndex?: number
  product: Product | null
}
const Accordion: FunctionComponent<AccordionType> = ({ items, defaultIndex, product }) => {
  const [indexOpened, setIndexOpened] = useState<number | null>(defaultIndex ?? null)

  const gtmEvent = () => {
    const gtmCategoryObj = gtmCategory(product?.gtm_categories)

    gtmPush({
      event: 'order_by_phone',
      ecommerce: {
        currency: product?.price_range?.minimum_price?.regular_price?.currency,
        value: product?.price_range?.minimum_price?.regular_price?.value,
        items: [
          {
            item_name: product?.gtm_name,
            item_id: product?.sku,
            price: product?.price_range.minimum_price.regular_price.value,
            item_brand: 'Messika',
            item_list_id: 'produit',
            item_list_name: 'Produit',
            index: product?.configurable_options?.[0]?.position ?? '',
            item_variant: product?.sku,
            ...gtmCategoryObj,
          },
        ],
      },
    })
  }

  useEffect(() => {
    const orderByPhone = document.querySelector('a.phone')

    orderByPhone?.addEventListener('click', () => gtmEvent())
  }, [])

  const handleAccordion = (index: number) => {
    if (index === indexOpened) {
      setTimeout(() => {
        setIndexOpened(null)
      }, 350)
      return
    }

    setIndexOpened(index)
  }
  return (
    <section className='accordion'>
      {items.map((item, index) => (
        <article
          key={`${item.title}`}
          className={`accordion-item ${indexOpened === index && 'open animated'}`}>
          <button className='accordion-item-button' onClick={() => handleAccordion(index)}>
            <h2 className='title-h5 accrodion-title'>{item.title}</h2>
            <Icon iconName={Icons.NAV_ARROW_DOWN} />
          </button>

          <div className={`content`}>{item.content}</div>
        </article>
      ))}
    </section>
  )
}

export default Accordion
